const EMPTY_BOTMARK_INFO = {
    name: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    email: '',
    phoneNumber: '',
};

/** Maps a Company API object (or BotmarkCompanyInfoDTO) to the botmarkInfo shape stored on estimates. */
export function mapCompanyToBotmarkInfo(company) {
    if (!company) {
        return { ...EMPTY_BOTMARK_INFO };
    }

    return {
        name: company.name ?? '',
        street: company.street ?? '',
        city: company.city ?? '',
        state: company.state ?? '',
        zip: company.zip ?? '',
        country: company.country ?? '',
        email: company.email ?? '',
        phoneNumber: company.phoneNumber ?? '',
    };
}

export function getBotmarkCompanyDisplayName(company, fallback = 'Botmark Inc.') {
    return company?.name || fallback;
}
